import { CustomContentProps } from 'notistack';
import { ReactNode } from 'react';

export enum NotificationTypes {
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}
export type PinnacleNotification = {
  type: NotificationTypes;
  title?: string;
  details?: string;
  timeout?: number;
};

export type PinnacleSnackbarProps = {
  children: ReactNode;
  notification?: PinnacleNotification,
};

export interface PinnacleNotificationCompleteProps extends Partial<CustomContentProps> {
  details?: string;
  title?: string;
  type: NotificationTypes;
  timeout?: number;
}